module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title6"
    }
  }), _c('div', {
    staticClass: "title-chapter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("F")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Faculty:")]), _vm._v(" Medieval psychology distinguishes several faculties of the soul which are said to be really distinct from each other and from the substance of the soul. According to Aquinas the distinction is based on objects and operations. The faculties are conceived as accidents of the soul’s substance, but as pertaining essentially to its nature, therefore “proper accidents.” The soul operates by means of the faculties.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Faculty psychology:")]), _vm._v(" The conception of mind as the unity in a number of special faculties, like sensibility, intelligence, volition, by reference to which individual processes of sensation, thought or will are explained. Faculty psychology, which originated in Plato’s division of the soul into the appetitive, the spirited and the rational faculties, was the dominant psychology of the Middle Ages. It is usually associated with the Soul Substance Theory of Mind.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fairy:")]), _vm._v(" A supernatural being, usually regarded as benign but inclined to mischief.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Faith:")]), _vm._v(" According to St. Augustine, faith means, to believe that which one does not see. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Fides ergo est, quod non vides credere")]), _vm._v(".) That is the reason why faith is praiseworthy.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Faith healing:")]), _vm._v(" A cure effected by the belief that disease and pain can be counteracted and cast out by faith in the Divine Power.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fakir:")]), _vm._v(" The term, properly, designates a Moslem mendicant ascetic and miracle-worker of India. It is often, incorrectly, applied to Hindu ascetics, too. According to Yogi Ramacharaka (in "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The Philosophies and Religions of Indian")]), _vm._v("), “the secret of the fakir’s power generally consists in his ability to produce a mental illusion, or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Maya,")]), _vm._v(" whereby the senses of the bystanders are deluded and the people made to appear to witness things that have no basis in fact. Another class of effects is produced by the control of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Prana")]), _vm._v(" (or Vital Force) by the concentrated Will of the performer, so that heavy objects are moved around in defiance of the law of gravitation, and even the human body at times being floated about in the air …”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fallen angel:")]), _vm._v(" An angel cast out from heaven for his sins, or for rebelling against God, and become an evil demon.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Familiar:")]), _vm._v(" A spirit who accompanies, and often helps, a magician, sorcerer or witch.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Familiarity:")]), _vm._v(" In astrology, a term used by Ptolemy to indicate an aspect or parallel between two bodies; or their mutual disposition, as when each is in the other’s Sign or House.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fana:")]), _vm._v(" In Sufism, the “self-attenuation,” or “self-effacement,” the final stage on the way to mystic union with God ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("tariqat")]), _vm._v("), the cleansing of the mirror of one’s impersonal heart and the unfettering from the attachment to material limitations which prevent the soul from apprehending the splendor of the “Real” which is behind and within all appearances. Four degrees of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("fana")]), _vm._v(" are described by the Sufi mystics: the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("fana fi seheikh,")]), _vm._v(" the complete suppression of one’s personality in obedience to one’s superior; the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("fana fir Rasul,")]), _vm._v(" self-attenuation or effacement of one’s personality in the gratitude for the Prophet, the vehicle of the grace of God; "), _c('em', {
    staticClass: "i"
  }, [_vm._v("fana Fillah,")]), _vm._v(" self-effacement or self-attenuation in God; and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("fana al fana,")]), _vm._v(" the attenuation of the attenuation, the stage beyond consciousness and unconsciousness.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Fanaticism: Zeal so excessive and irrational as to impair self-criticism and destroy moral perspective.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fang shih:")]), _vm._v(" Chinese for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("man with formulae.")]), _vm._v(" A primitive Chinese priest-magician.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fang shui:")]), _vm._v(" A Chinese term for magic and occult arts.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Far-going, Stage of:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Dasa-bhumi.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fascination:")]), _vm._v(" In the terminology of occultism, magic and witchcraft, this word means a charm, bewitchment, enchantment.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fat of the sorcerers:")]), _vm._v(" The human fat which sorcerers and witches were accused, in the Middle Ages, of using.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fatalism:")]), _vm._v(" The belief that all events and human activities are predetermined by divine power.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fates:")]), _vm._v(" The three Roman goddesses ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Parcœ")]), _vm._v(") who presided over the birth and life of mankind. Their names were Atropos, Clotho and Lachesis.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Father-Mother:")]), _vm._v(" In esoteric philosophy, the world substance or world soul (q.v.). In Christian Science, a name for God.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Faun:")]), _vm._v(" A nature spirit, half man, half goat, venerated as a rural deity by the ancient Romans. The Fauns were attendants of Pan.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fay:")]), _vm._v(" Fairy.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Felicific:")]), _vm._v(" Conducive to pleasure or happiness.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fellow of the Craft:")]), _vm._v(" In Freemasonry, an individual who has attained the second degree of initiation.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Feminine principle; female force:")]), _vm._v(" In esoteric philosophy, the passive, negative or receptive aspect of the cosmic order, force or of the deity. Matter, wisdom, form are usually conceived of as feminine and are represented by goddesses in the pantheons of the polytheistic religions.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fenrir:")]), _vm._v(" In Norse mythology, a wolfish monster, offspring of Loki. One of the enemies of the Norse gods, he is to swallow Odin himself at the last day, and also to swallow the sun. (Also called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Fenrisulf")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fetch:")]), _vm._v(" The name given in Ireland to a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("wraith")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fetch-lights:")]), _vm._v(" Mysterious luminous apparitions which the folklore interprets as indications of impending death.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fetish:")]), _vm._v(" A material object venerated as the temporary or permanent abode of a soul or spirit.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fetishism:")]), _vm._v(" The belief in fetishes or the worship of a fetish as a deity.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Field of consciousness:")]), _vm._v(" The sum total of items embraced within an individual’s consciousness at any given moment. The total field consists of: (a) the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("focus,")]), _vm._v(" where the concentration of attention is maximal, and (b) a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("margin, periphery")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("fringe")]), _vm._v(" of a diminishing degree of attention which gradually fades to zero.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Figure:")]), _vm._v(" An astrological or Celestial Figure, variously called Geniture, Map, Scheme, Chart, Theme, Mirror of Heaven, Nativity or Horoscope, as cast, erected or drawn by modern astrologers, consists of a circle of the heavens, representing the 360° of the Earth’s orbit, divided into twelve arcs—resembling a wheel of twelve spokes. These arcs may represent Signs of 30° each beginning at the Spring equinoctial point, or Houses of an indeterminate number of degrees beginning at an ascending degree. A Solar Figure, used where a specific moment of birth is not known, employs the Sun’s degree as the point of beginning, or Ascendant. The Houses or geo-arcs, based upon the degree rising in the east at the specific moment for which the Figure is cast, supposedly represent the number of degrees which pass over the horizon in two hours from that particular longitude and latitude and on that day. The Sign-divisions, or heliarcs, are thus subdivisions of the Earth’s annual orbit round the Sun, while the House-divisions, or geo-arcs, are subdivisions of the daily orbit of a particular point on the Earth’s surface around the Earth’s axis.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Figurine:")]), _vm._v(" A small carved or molded figure of a human being, animal, bird, etc.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Finalism:")]), _vm._v(" The belief that the universe is striving for definite ends or for one supreme end.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Finite god:")]), _vm._v(" A god whose power is limited by realities which are not his own creation.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fire:")]), _vm._v(" Esoterically, one of the four Elements. In the teachings of Rosicrucians and Hermetists, fire, like man, has a body (the visible flame), a soul (astral fire) and spirit, and it has a fourfold aspect—heat (equivalent to life), light (equivalent to mind), electricity (molecular powers), and the radical cause of its existence.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fire Philosophers:")]), _vm._v(" A designation applied to the medieval alchemists and Hermetists and also to the Rosicrucians.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fire signs:")]), _vm._v(" In astrology, the “inspirational” signs: Aries, Leo, Sagittarius.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fire-worship, fire-worshipper:")]), _vm._v(" An expression often used to refer to Zoroastrianism (q.v.) and its adherents.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("First heaven:")]), _vm._v(" The outermost sphere of the Aristotelian cosmology, the sphere of the fixed stars.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("First fruits:")]), _vm._v(" The offering of the first produce of the earth, the first animals killed or trapped in the hunting season, the firstlings of the flock, etc., to the gods most concerned with that particular activity which produced these first fruits, etc., or to the priests of those gods. In ancient days, the practice extended sometimes also to the first child of a man.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fishes:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Pisces.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Five Agents:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Wu hsing.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Flagae:")]), _vm._v(" Familiar spirits; spirits visible in mirrors and able to reveal certain things.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Flaming Wisdom, Stage of:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Dasa-bhumi.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Flexed:")]), _vm._v(" An alternate astrological term, preferred by some modern astrologers, for the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("mutable signs.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fluid body:")]), _vm._v(" A synonymous term for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astral body")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Flux:")]), _vm._v(" The characteristic of time, by virtue of which all things change inevitably.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fohat:")]), _vm._v(" A Tibetan term for the primordial cosmic substance of occult teachings.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Folklore:")]), _vm._v(" The surviving beliefs, legends, myths and traditions of a people, usually transmitted by word of mouth.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Foolish fire:")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ignis fatuus")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Forcas (Foras, Furcas):")]), _vm._v(" In demonography, a powerful demon of the infernal empire.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Foreknowledge:")]), _vm._v(" Knowledge of the future.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Forest Books:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aranyakas.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Formalism:")]), _vm._v(" The attachment of great significance to the scrupulous observance of external rules.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fortified:")]), _vm._v(" An astrological term, meaning strongly placed (either elevated, in a congenial Sign, or well-aspected).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fortuna:")]), _vm._v(" The Roman goddess of fortune, one of the most powerful goddesses of the Roman pantheon; she was believed to bestow riches or poverty on mortals.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fortune-telling:")]), _vm._v(" Divination; foretelling the future.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fortunes:")]), _vm._v(" In astrological terminology, the benefic planets: Jupiter, the “Greater Fortune”; and Venus, the “Lesser Fortune.” The Sun and Mercury, or by some authorities the Moon and Mercury, when well placed and aspected, particularly if by Jupiter or Venus, are sometimes so classed.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Four-footed signs:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Quadrupedal signs.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Four Noble Truths:")]), _vm._v(" The "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aryani Satyani,")]), _vm._v(" the four basic principles of the teachings of Gautama Buddha: the Truth of Suffering, the Truth of the Cause of Suffering, the Truth of the Cessation of Suffering, the Truth of the Path to the Ending of Suffering.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fourth dimension:")]), _vm._v(" A higher order of space, additional to the three known dimensions of height, width and length; a direction which is neither up-or-down nor right-or-left nor back-or-forth, but at right angles to all three. Many philosophers consider "), _c('em', {
    staticClass: "i"
  }, [_vm._v("time")]), _vm._v(" (duration, the past-or-present direction) a fourth dimension—but the “fourth dimension” just described is conceived of as a fourth "), _c('em', {
    staticClass: "i"
  }, [_vm._v("spatial")]), _vm._v(" dimension. In occult terminology, the fourth dimension has to do with internal qualities which, when seen in the astral light, become visible. It has been defined as “the sum of the other three dimensions,” and also as “man’s expanding sense of time.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fravashi:")]), _vm._v(" In Zoroastrian occultism, the guardian angel of the believer.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Freemasonry:")]), _vm._v(" A world-wide philosophical fraternal institution. Its origins are lost in the immemorial past, although it is claimed to have been founded at the time of the building of Solomon’s Temple; its present organization dates from 1717, the establishment of the premier Grand Lodge of England. It teaches morality and basic religion by means of symbols, particularly those derived from the builder’s craft; its basic doctrines include belief in God, the Great Architect of the Universe, and belief in the immortality of the soul. A great deal of ancient and medieval occult lore, particularly of the Kabalah and of alchemy, has been retained by the Order in a more or less modified form. According to H. L. Haywood, in "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Supplement to Mackey’s Encyclopedia of Freemasonry")]), _vm._v(" (copyright, 1946, by the Masonic History Company), Vol. III, p. 1234, “A Masonic Lodge represents a body of workmen in which each member has a station or place corresponding to his task or function.” It is stated in the same volume (p. 1485) that “there is no occultism in Freemasonry, though the word is often used loosely in the Ritual, as a synonym for ‘arcane.’ The correct Masonic word is ‘esoteric.’”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Free-will:")]), _vm._v(" A doctrine that applies to the exercise of the will in overcoming the obstacles of terrestrial environment and cosmic influences, whereby so to control and direct cosmic forces operating at a given time, as to transmute them into power under control. It is opposed to any such yielding to an influence as that which is called Fate.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fruitful signs:")]), _vm._v(" In astrology, Cancer, Scorpio and Pisces; the Water Signs.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Frigga:")]), _vm._v(" Wife of Odin in Norse mythology, mother of Thor, Balder and other gods, patroness of conjugal love. Variously regarded as goddess of the earth and air.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Frustration:")]), _vm._v(" A term used in horary astrology when one planet is applying to an aspect of another, which aspect would tend to signify some event; but before such aspect culminates, a third planet, by its swifter motion, interposes to anticipate the culmination of the forming aspect by completing one of its own.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fu:")]), _vm._v(" A Chinese term, meaning correspondence, especially that between man and the universe in the macrocosm-microcosm relationship.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fu lu shou:")]), _vm._v(" In Chinese philosophy, the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Three Plenties—")]), _vm._v("blessing or happiness, official emolument and the honor which it brings, and longevity. They are also called the Three Stars, as each of them is believed to be dependent on a star-god. They are represented either by the three corresponding Chinese ideographic characters, or by a bat ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("fu")]), _vm._v(") symbolizing happiness, a deer ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("lu")]), _vm._v(") symbolizing honor, and a peach ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("shou")]), _vm._v(") symbolizing longevity, or by a smiling figure, with or without children surrounding him, to represent happiness, an official to represent honor, and an old man to represent longevity. These representations are used as charms, as objects of worship, or simply as felicitations.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Funke:")]), _vm._v(" German for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("spark.")]), _vm._v(" In the philosophy of J. G. Fichte, the divine spark, the life that stirs and wells up within the individual.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Furies:")]), _vm._v(" In Roman mythology, the three sisters Alecto, Megæra and Tisiphone, punishers of evildoers, personifications of rage, envy and slaughter.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Future:")]), _vm._v(" That part of time which includes all the events which will happen. According to many occultists and esoteric philosophers, the future co-exists with the present and the past, time is indivisible, unchangeable, and past, present and future are merely concepts of the human mind which moves along a “time track” through the reality which is time; foreknowledge, prophecy, etc., can be explained as glimpses ahead along the time track.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eecf4934","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/e9780806537009_c06.vue
// module id = 90
// module chunks = 0